export const LOCAL_FORAGE_DATABASE_NAME: string = "tenera_local_store";
export const LOCAL_FORAGE_UPLOAD_STATUS_TABLE_NAME: string = "attachment_upload_status";
export const LOCAL_FORAGE_UPLOAD_ATTACHMENT_RECORD_TABLE_NAME: string = "attachment_upload_record";
export const LOCAL_FORAGE_OFFLINE_PROPERTY_TABLE_NAME: string = "offline_property_list";
export const LOCAL_FORAGE_PENDING_UPLOAD_PROPERTY_TABLE_NAME: string = "pending_upload_property_list";